import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./main.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root-Element #root fehlt");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
